/**
 * Games Year Filter Component
 * Handles form submission for games year filtering
 * Redirects to /pages/games-YYYY for past years, /pages/games for current year
 * For EN pages: /pages/en-games-YYYY or /pages/en-games
 */

class GamesYearFilter extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.select = this.querySelector('select');

    if (this.form && this.select) {
      this.init();
    }
  }

  getBasePageUrl() {
    const pageUrl = this.dataset.blogUrl || window.location.pathname;
    const match = pageUrl.match(/^(\/pages)(?:\/games(?:-en)?(?:-\d{4})?)?/);
    if (match) {
      return match[1];
    }
    return '/pages';
  }

  isEnglishPage() {
    const pageUrl = this.dataset.blogUrl || window.location.pathname;
    return pageUrl.includes('en-games') || pageUrl.includes('/en');
  }

  getCurrentYear() {
    return new Date().getFullYear();
  }

  init() {
    this.form.addEventListener('submit', (e) => {
      e.preventDefault();

      const selectedYear = this.select.value;
      const currentYear = this.getCurrentYear();
      const isEn = this.isEnglishPage();

      if (!selectedYear) {
        const pageUrl = this.dataset.blogUrl || (isEn ? '/pages/en-games' : '/pages/games');
        window.location.href = pageUrl;
        return;
      }

      const selectedYearNum = parseInt(selectedYear, 10);

      if (selectedYearNum === currentYear) {
        window.location.href = isEn ? '/pages/en-games' : '/pages/games';
        return;
      }

      const baseUrl = this.getBasePageUrl();
      const prefix = isEn ? 'en-games' : 'games';
      window.location.href = `${baseUrl}/${prefix}-${selectedYear}`;
    });
  }
}

if (!customElements.get('games-year-filter')) {
  customElements.define('games-year-filter', GamesYearFilter);
}

document.addEventListener('DOMContentLoaded', () => {
  const gamesYearFilters = document.querySelectorAll('.games-year-filter');

  gamesYearFilters.forEach((filter) => {
    const form = filter.querySelector('form');
    const select = filter.querySelector('select');

    if (!form || !select) return;

    const getBasePageUrl = () => {
      const pageUrl = filter.dataset.blogUrl || window.location.pathname;
      const match = pageUrl.match(/^(\/pages)(?:\/games(?:-en)?(?:-\d{4})?)?/);
      return match ? match[1] : '/pages';
    };

    const isEnglishPage = () => {
      const pageUrl = filter.dataset.blogUrl || window.location.pathname;
      return pageUrl.includes('en-games') || pageUrl.includes('/en');
    };

    const getCurrentYear = () => {
      return new Date().getFullYear();
    };

    form.addEventListener('submit', (e) => {
      e.preventDefault();

      const selectedYear = select.value;
      const currentYear = getCurrentYear();
      const isEn = isEnglishPage();

      if (!selectedYear) {
        const pageUrl = filter.dataset.blogUrl || (isEn ? '/pages/en-games' : '/pages/games');
        window.location.href = pageUrl;
        return;
      }

      const selectedYearNum = parseInt(selectedYear, 10);

      if (selectedYearNum === currentYear) {
        window.location.href = isEn ? '/pages/en-games' : '/pages/games';
        return;
      }

      const baseUrl = getBasePageUrl();
      const prefix = isEn ? 'en-games' : 'games';
      window.location.href = `${baseUrl}/${prefix}-${selectedYear}`;
    });
  });
});
